import { SearchScenarioId } from 'owa-search-next-common';
import { PillSuggestion } from 'owa-search-service';
import { action } from 'satcheljs';

const onPillSuggestionSelected = action(
    'onPillSuggestionSelected',
    (
        suggestionPill: PillSuggestion,
        suggestionSelected: boolean,
        scenarioId: SearchScenarioId
    ) => ({
        suggestionPill,
        suggestionSelected,
        scenarioId,
    })
);

export default onPillSuggestionSelected;
